/*
 * Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { DatePipe } from '@angular/common';
/**
 * Takes in UNIX format timestamp and returns a
 * long format date with a relative message by comparison to now
 * e.g give timestamp for 01/01/2024 UTC which was 8 days from today (today - 8 days) -> "8 days ago"
 * TODO: Replace customer app implementation with this one
 */
@Pipe({
  name: 'humaneDates',
  standalone: true
})
export class HumaneDatesPipe implements PipeTransform {

  DEFAULT_FORMAT = "long";
  DEFAULT_TIMEZONE = "UTC";

  constructor(private datePipe: DatePipe) {
  }

  transform(timestamp: number | string | Date, format?: string, timezone?: string): string {
    return this.datePipe.transform(timestamp,format? format: this.DEFAULT_FORMAT,timezone?timezone:this.DEFAULT_TIMEZONE) + ' - ' + moment(timestamp).fromNow();
  }
}
